/* Жизнен — голямото меню се отваря на КЛИК (одобрено 31.07.2026).
   Не пипаме кода на темата: тя си слага своя клас при минаване с мишката,
   но стиловете в jzn-nav-click.css правят така, че само нашият клас отваря. */
(function () {
  var OPEN = 'jzn--open';
  var SEL = '[data-menu-nav] > li.t4s-menu-item.has--children';

  function desktop() { return window.matchMedia('(min-width: 1025px)').matches; }

  function all() { return document.querySelectorAll(SEL); }

  function closeAll(except) {
    all().forEach(function (li) { if (li !== except) li.classList.remove(OPEN); });
  }

  // capture: изпреварваме евентуален чужд обработчик върху същата връзка
  document.addEventListener('click', function (e) {
    if (!desktop()) return;
    var a = e.target.closest ? e.target.closest(SEL + ' > a') : null;
    if (a) {
      var li = a.parentElement;
      var wasOpen = li.classList.contains(OPEN);
      e.preventDefault();
      e.stopPropagation();
      closeAll();
      if (!wasOpen) li.classList.add(OPEN);
      return;
    }
    if (!e.target.closest || !e.target.closest('[data-menu-nav]')) closeAll();
  }, true);

  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') closeAll();
  });

  // затваряме и при връщане назад/напред и при смаляване до телефон
  window.addEventListener('pageshow', function () { closeAll(); });
  window.addEventListener('resize', function () { if (!desktop()) closeAll(); });
})();
